import { decorate, observable } from "mobx";
import CustomClipsStore from "./CustomClipsStore";

class AllCustomClipsStore extends CustomClipsStore {
  fetchClips(params) {
    this.sportyApi.getAllCustomClips(params).then(result => {
      this.clips = result.customClips;
      this.totalClips = result.total;
    });
  }
}

decorate(AllCustomClipsStore, {
  gamePk: observable,
  description: observable,
  page: observable,
  clips: observable,
  clipsPerPage: observable,
  totalClips: observable
});

export default AllCustomClipsStore;



// WEBPACK FOOTER //
// ./src/stores/customClips/AllCustomClipsStore.js